<template>
  <v-dialog v-model="isVisible" max-width="800px" @click:outside="$emit('callback-cancel')" @keydown.esc="$emit('callback-cancel')">
    <v-card class="mx-auto">
      <v-system-bar>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('callback-cancel')">mdi-close</v-icon>
      </v-system-bar>
      <v-card-title>※ 대기 목록에 1개 이상이 남아있게 되면 목록에 “대기중”으로 보여집니다. <br /> 승인 또는 거절을 전부 체크해주세요.</v-card-title>
      <v-card-text>
        <v-container>

          <article class="tableWrap">
            <div class="tableBtnBx">
              <p class="searchAll">
                분과 목록
              </p>
              <div class="tableBtn">
                <ul>
                  <li class="tableBtnList">
                    <v-select :items="departmentItems" item-value="groupId" item-text="groupName" v-model="addDepartment"
                              dense
                              flat
                              clearable
                              return-object
                              label="분과 선택"/>
                  </li>
                  <li class="tableBtnList">
                    <v-btn class="vBtn vIconResize mgr" @click="changeDepartment" color="#666" dark>
                      <v-icon left>mdi mdi-playlist-plus</v-icon>
                      변경
                    </v-btn>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tableBx">
              <v-data-table
                  id="departmentTable"
                  item-key="groupId"
                  :hide-default-footer="true"
                  disable-pagination
                  :headers="departmentHeader"
                  :items="departments"
                  class="elevation-1"
              >
                <template v-slot:item.joinState="{value}">
                  {{ value === 'STATE_REQUEST' ? '대기' : value === 'STATE_APPROVAL' ? '승인' : '거절'}}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn color="primary" small dark style="margin-right: 3px;" @click="updateState('STATE_REQUEST', item.groupId, 'department')">대기</v-btn>
                  <v-btn color="success" small dark style="margin-right: 3px;" @click="updateState('STATE_APPROVAL', item.groupId, 'department')">승인</v-btn>
                  <v-btn color="warning" small dark style="margin-right: 3px;" @click="updateState('STATE_DENIED', item.groupId, 'department')">거절</v-btn>
                  <v-btn color="grey" small dark @click="deleteGroup(item.groupId, 'department')">삭제</v-btn>
                </template>
              </v-data-table>
            </div>
          </article>

          <article class="tableWrap">
            <div class="tableBtnBx">
              <p class="searchAll">
                동호회 목록
              </p>
              <div class="tableBtn">
                <ul>
                  <li class="tableBtnList">
                    <v-select :items="clubItems" item-value="groupId" item-text="groupName" v-model="addClub"
                              dense
                              flat
                              clearable
                              return-object
                              label="동호회 선택"/>
                  </li>
                  <li class="tableBtnList">
                    <v-btn class="vBtn vIconResize mgr" @click="appendDepartment" color="#666" dark>
                      <v-icon left>mdi mdi-playlist-plus</v-icon>
                      추가
                    </v-btn>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tableBx">
                <v-data-table
                    id="clubTable"
                    item-key="groupId"
                    :hide-default-footer="true"
                    disable-pagination
                    :headers="clubHeader"
                    :items="clubs"
                    class="elevation-1"
                >
                  <template v-slot:item.joinState="{value}">
                    {{ value === 'STATE_REQUEST' ? '대기' : value === 'STATE_APPROVAL' ? '승인' : '거절'}}
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn color="primary" small dark style="margin-right: 3px;" @click="updateState('STATE_REQUEST', item.groupId, 'club')">대기</v-btn>
                    <v-btn color="success" small dark style="margin-right: 3px;" @click="updateState('STATE_APPROVAL', item.groupId, 'club')">승인</v-btn>
                    <v-btn color="warning" small dark style="margin-right: 3px;" @click="updateState('STATE_DENIED', item.groupId, 'club')">거절</v-btn>
                    <v-btn color="grey" small dark @click="deleteGroup(item.groupId, 'club')">삭제</v-btn>
                  </template>
                </v-data-table>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#666" dark @click="$emit('callback-cancel')">닫기</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </article>
        </v-container>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>
<script>
// import userApi from "@/api/UserApi";
import _ from 'lodash';
import groupApi from "@/api/GroupApi";

export default {
  name: "UserGroup",
  components: {
  },
  props: {
    isVisible: Boolean,
    item: Object
  },
  watch: {
    item: {
      handler(nv) {
        this.user = _.cloneDeep(nv);
        this.departments = this.user?.departmentGroup??[];//.filter(e => e.joinState === 'STATE_REQUEST');
        this.clubs = this.user?.clubGroup??[];//.filter(e => e.joinState === 'STATE_REQUEST');
      },
      deep: true
    }
  },
  computed: {
    departmentItems() {
      return this.initLoadDepartmentItems.filter(i => !this.departments.map(d => d.groupId).includes(i.groupId));
    },
    clubItems() {
      return this.initLoadClubItems.filter(i => !this.clubs.map(d => d.groupId).includes(i.groupId));
    }

  }
  ,
  data: () => ({
    user:{},
    departments:[],
    clubs:[],
    departmentHeader:[
      {text: '분과', value: 'groupName', sortable: false, align: 'center'},
      {text: '상태', value: 'joinState', sortable: false, align: 'center'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    clubHeader:[
      {text: '동호회', value: 'groupName', sortable: false, align: 'center'},
      {text: '상태', value: 'joinState', sortable: false, align: 'center'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    isModify:false,
    errorMessages:'',
    initLoadDepartmentItems:[],
    initLoadClubItems:[],
    addDepartment:null,
    addClub:null
  }),
  methods: {
    changeDepartment() {

      this.addDepartment.joinState = 'STATE_REQUEST';
      this.departments = [this.addDepartment];

      this.$emit('callback-appended', this.addDepartment.groupId, true)
    },
    appendDepartment() {
      this.addClub.joinState = 'STATE_REQUEST';
      this.clubs = [...this.clubs, this.addClub];

      this.$emit('callback-appended', this.addClub.groupId, false);
    },
    async updateState(state, groupId, groupType) {

      try {
        this.departments?.filter(g => g.groupId === groupId)?.forEach(g => g.joinState = state);
        this.clubs?.filter(g => g.groupId === groupId)?.forEach(g => g.joinState = state);

        this.$emit('callback-changed', groupId, state, groupType);

        // userApi.updateUserGroupState(state, groupId, this.user.userId).then(() => {
        //   this.departments?.filter(g => g.groupId === groupId)?.forEach(g => g.joinState = state);
        //   this.clubs?.filter(g => g.groupId === groupId)?.forEach(g => g.joinState = state);
        //   this.$emit('callback-changed', this.item, groupId, state);
        // });

      } catch (error) {
        alert(error.response.data.message);
      }
    },
    deleteGroup(groupId, groupType) {
      if(confirm('삭제하시겠습니까?')) {
        if(groupType === 'department')
          this.departments = this.departments.filter(g => g.groupId !== groupId);
        else
          this.clubs = this.clubs.filter(g => g.groupId !== groupId);
        this.$emit('callback-deleted', groupId);
      }
    }
  },
  created() {
    groupApi.flatActiveList(1).then(data => {
      this.initLoadDepartmentItems = data;
    });
    groupApi.flatActiveList(2).then(data => {
      this.initLoadClubItems = data;
    });
  }
}
</script>

<style lang="scss" scoped>
.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        margin-right: 15px;
      }
    }
  }
}
</style>